import dayjs from "dayjs";
import { useFormik } from "formik";
import { enqueueSnackbar } from "notistack";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import * as yup from "yup";
import { PAGE_LOGIN } from "../../locales/pages/namespaces";
import useUserAction from "../user/useUserAction";
import useUserData from "../user/useUserData";
import axios from "axios";
import {API} from "../../helpers/constants";
import {normalizeProductKeepLang} from "../../helpers/products/normalizeProduct";
import {handleAxiosErrors} from "../../helpers/errorHandling";

const useForgotPassword = ({ onClose }) => {
	const { t } = useTranslation(PAGE_LOGIN)
	const {token} = useUserData()
	const onSubmit = (values) => {
		axios({
			method: "get",
			url: `${API}/en/request/new-password?username=${values.email}`,
			headers: {
				"Content-Type": "application/json", Authorization: `Bearer ${token}`  ,
			},
			data: {
				username: values.email,
			},
		})
			.then((res) => {
				onClose();
				enqueueSnackbar(t("Submitted!"), {
					variant: "success",
					autoHideDuration: 3000,
				});

			})
			.catch((error) => {
				enqueueSnackbar(handleAxiosErrors(error, t("An error occurred!")), {
					variant: "error",
					autoHideDuration: 3000,
				});
			})
	}
	

	
	const validationSchema = yup.object({
		email: yup
		.string()
		.required(t('Required')),
	})
	
	const formik = useFormik({
		initialValues: {
			email:''
		},
		validationSchema: validationSchema,
		onSubmit: onSubmit,
	})
	
	return {
		formik
	}
}

export default useForgotPassword